import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const sushitomoCustomerGroup = 'sushi_tomo';
export const customerGroup = sushitomoCustomerGroup;

const supportEmail = {
	sushi_tomo: 'sushitomo@smoothr.de'
};
const firebaseConfig = {
	sushi_tomo: {
		apiKey: 'AIzaSyD6ts0Id_SBkRWvMFMf5O3gnv77OJ6isho',
		authDomain: 'sushitomo-755ae.firebaseapp.com',
		projectId: 'sushitomo-755ae',
		storageBucket: 'sushitomo-755ae.firebasestorage.app',
		messagingSenderId: '473798940957',
		appId: '1:473798940957:web:8496aca4de0377b99de9f4'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBluJcdTIOEgFGyzc1GedbP4nOdE-wypiY',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment
};
